// Languages people can pick in Settings. The AI replies in it, and staff check-ins are translated into it.
// Kept in one place: the app (Settings, check-in translation) and the edge functions use the same codes.
export interface Language { code: string; name: string; native: string }

export const LANGUAGES: Language[] = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'pt', name: 'Portuguese', native: 'Português' },
  { code: 'ar', name: 'Arabic', native: 'العربية' },
  { code: 'it', name: 'Italian', native: 'Italiano' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'el', name: 'Greek', native: 'Ελληνικά' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands' },
  { code: 'pl', name: 'Polish', native: 'Polski' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'uk', name: 'Ukrainian', native: 'Українська' },
  { code: 'he', name: 'Hebrew', native: 'עברית' },
  { code: 'fa', name: 'Persian', native: 'فارسی' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'ne', name: 'Nepali', native: 'नेपाली' },
  { code: 'bn', name: 'Bengali', native: 'বাংলা' },
  { code: 'ur', name: 'Urdu', native: 'اردو' },
  { code: 'pa', name: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்' },
  { code: 'si', name: 'Sinhala', native: 'සිංහල' },
  { code: 'zh', name: 'Chinese (Mandarin)', native: '中文' },
  { code: 'yue', name: 'Cantonese', native: '粵語' },
  { code: 'ja', name: 'Japanese', native: '日本語' },
  { code: 'ko', name: 'Korean', native: '한국어' },
  { code: 'th', name: 'Thai', native: 'ไทย' },
  { code: 'vi', name: 'Vietnamese', native: 'Tiếng Việt' },
  { code: 'id', name: 'Indonesian', native: 'Bahasa Indonesia' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu' },
  { code: 'tl', name: 'Filipino', native: 'Filipino' },
  { code: 'mn', name: 'Mongolian', native: 'Монгол' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili' },
];

export const languageByCode = (code: string | null | undefined): Language | null =>
  LANGUAGES.find((l) => l.code === code) ?? null;
